export default __webpack_public_path__ + "static/media/custom_webhook.4b0d26b4.svg";